import fetch from 'isomorphic-fetch';
import { API as url1 } from '../config';
import { KEYWORD } from '../constants/url';

//KEYWORD
export const getKeywords = () => {

    return fetch(`${url1}${KEYWORD}/all`, {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
    })
        .then(response => {
            return response.json();
        })
        .catch(err => console.log(err));
};

export const deleteKeyword = (keywordId) => {
    return fetch(`${url1}${KEYWORD}/${keywordId}`, {
        method: 'DELETE',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(response => response.json())
        .catch(err => console.log(err));
};
export const addKeyword = (keyword) => {
    return fetch(`${url1}${KEYWORD}/add`, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(keyword)
    })
        .then(response => {
            return response.json();
        })
        .catch(err => console.log(err));
};
export const updateKeyword = (keyword, keywordId) => {
    return fetch(`${url1}${KEYWORD}/edit/${keywordId}`, {
        method: 'PUT',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(keyword)
    })
        .then(response => {
            return response.json();
        })
        .catch(err => console.log(err));
};
